module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/redo-72bd492524e47d608b7b088f6a05dca7.svg";